import { createValidator, maxMonthsPeriod, requiredPeriod } from 'util/validation'
import { isValid } from 'util/validation/Util'

import {
  AssinaturaEletronicaAtendTableFilterModel,
  MESES_PERIODO_ASSINATURA_DIGITAL,
} from './model-assinaturaEletronicaAtend'

export const validateAssinaturaDigitalFilter = createValidator<AssinaturaEletronicaAtendTableFilterModel>(
  { periodo: [requiredPeriod] },
  ({ periodo }, errors) => {
    if (isValid(errors.periodo)) {
      errors.periodo = maxMonthsPeriod(periodo, MESES_PERIODO_ASSINATURA_DIGITAL)
    }
    return errors
  }
)
